import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { AuthService } from 'src/app/core/services/user-services/auth.service';

@Component({
  selector: 'app-changeemail-callback',
  templateUrl: './changeemail-callback.component.html',
  styleUrls: ['./changeemail-callback.component.scss']
})
export class ChangeemailCallbackComponent implements OnInit {

  constructor(private router: Router, private auth: AuthService) { }

  ngOnInit(): void {
    this.auth.completeChangeEmail();
    this.router.navigateByUrl('/menu/profilo');
  }

}
